import { RELOCATION_OPTIONS } from "constants/relocation";

export const removeEmptyLocations = (locations) => {
    return locations.filter(
        (location) =>
            location &&
            Object.keys(location).length > 0 &&
            location.title &&
            location.title.trim() !== "",
    );
};

export const mapCandidateSelectedOption = (relocation) => {
    if (!relocation) return -1;
    if (
        ( relocation?.availability == null && relocation?.relocationAvailability == null) ||
        ( relocation?.relocateAnywhere == null && relocation?.relocationAnywhere == null)
    ) {
        return -1;
    }
    if (
        ( relocation?.relocateAnywhere === true || relocation?.relocationAnywhere === true) &&
        ( relocation?.availability === true || relocation?.relocationAvailability === true)
    ) {
        return RELOCATION_OPTIONS.ANYWHERE;
    } else if (
        ( relocation?.relocateAnywhere === false || relocation?.relocationAnywhere === false) &&
        ( relocation?.availability === true || relocation?.relocationAvailability === true)
    ) {
        return RELOCATION_OPTIONS.SPECIFIC_LOCATIONS;
    } else if (( relocation?.availability === false || relocation?.relocationAvailability === false)) {
        return RELOCATION_OPTIONS.NOT_WILLING;
    }
    return -1;
};

export const relocationOptionIdToData = (selectedValue) => {
    let updatedData = {};
    if (selectedValue === null) return updatedData;
    selectedValue = parseInt(selectedValue);
    if (selectedValue === RELOCATION_OPTIONS.NOT_WILLING) {
        updatedData = {
            relocationAvailability: false,
            relocationAnywhere: false,
        };
    } else if (selectedValue === RELOCATION_OPTIONS.ANYWHERE) {
        updatedData = {
            relocationAvailability: true,
            relocationAnywhere: true,
        };
    } else {
        updatedData = {
            relocationAvailability: true,
            relocationAnywhere: false,
        };
    }

    return updatedData;
};